import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    flexGrow: 100
  },
  fullHeight: {
    height: "100%",
    overflow: "auto"
  }
}));
